export default __webpack_public_path__ + "static/media/enterpriseEu.7b01ffb3.svg";